module.exports = __webpack_public_path__ + "static/media/3.06922177.svg";